/**
 * A super module that collects available sub-modules.
 *
 * @namespace vef.map.popup.templates
 * @memberof vef.map.popup
 */

import { PopupRenderer } from "../PopupRenderer.js";

import kdm_popup from './kdm.popup.md?raw';
import kdm_sidebar from './kdm.sidebar.md?raw';
import opus from './opus.md?raw';
import { geoJSONLayer } from './geoJSONLayer.js';
import { measurementsLayer } from './measurementsLayer.js';

// register static templates
PopupRenderer.registerTemplate('kdm_popup', kdm_popup);
PopupRenderer.registerTemplate('kdm_sidebar', kdm_sidebar);
PopupRenderer.registerTemplate('opus', opus);
// register dynamic templates
PopupRenderer.registerTemplate('geojson_layer', geoJSONLayer);
PopupRenderer.registerTemplate('measurements_layer', measurementsLayer);